// PT-BR
export const locale = {
	lang: 'pt-br',
	data: {
		TRANSLATOR: {
			SELECT: 'Selecione seu idioma',
		},
		PAYMENT:
		{
			INVALID_NAME: "Preenchaum nome válido",
			INVALID_CPF: "Preencha um cpf válido",
			INVALID_ADDRESS: "Preencha endereço válido",
			INVALID_CITY: "Preencha uma cidade  válido",
			INVALID_STATE: "Preencha um estado  válido",
		},
		MENU: {
			CUSTOMER:{
				LOTTERY:
				{
					MYBETS:"Minhas Apostas",
					LABORATORY:"Laboratório",
					CONFIGS:"Configurações",
					FILTERS:"Filtros",
					FILTERS_DEFAULT:"Filtros Padrão",
					STATISTICS:"Estatísticas",
					FREQUENCYUP:"Maior Frequência",
					LASTCONTEST:"Último Sorteio",
					RESULTS:"Resultados",
					MANUAL:"Manuais e Vídeos"
				}
			},
			NEW: 'new',
			ACTIONS: 'Ações',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			DASHBOARD: 'Dashboard bRASIL'
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'Ainda não possui conta de acesso?',
				SIGNUP_BUTTON: 'Cadastrar acesso',
				FORGOT_BUTTON: 'Esqueci a senha',
				BACK_BUTTON: 'Voltar',
				PRIVACY: 'Privacidade',
				LEGAL: 'Legal',
				CONTACT: 'Contato',
			},
			CONFIRM_EMAIL: "Confirmação de email",
			LOGIN: {
				TITLE: 'Acessar o sistema',
				BUTTON: 'Entrar',
			},
			FORGOT: {
				TITLE: 'Esqueceu a senha ?',
				DESC: 'Digite seu email para receber sua senha',
				SUCCESS: 'Sua senha foi enviada com sucesso. Verifique as mensagens em seu email.',
				NOT_FOUND: 'Seu email não foi encontrado em nossa base de dados. Verifique se digitou corretamente ou clique em voltar e cadastre seu acesso'
			},
			REGISTER: {
				TITLE: 'Registro',
				DESC: 'Preencha seus dados para criar sua conta',
				SUCCESS: 'Sua conta foi criada com sucesso',
				CONFIRM_EMAIL: 'Para finalizar seu cadastro acesse seu email para confirmação'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Nome',
				PASSWORD: 'Senha',
				CONFIRM_PASSWORD: 'Confirme sua senha',
				USERNAME: 'Usuaário'
			},
			VALIDATION: {
				INVALID: '{{name}} inão é válido',
				REQUIRED: '{{name}} é obrigatório',
				MIN_LENGTH: '{{name}} menor que o mínimo de {{min}}',
				AGREEMENT_REQUIRED: 'Aceitação dos termos é obrigatória',
				NOT_FOUND: 'Campo requerido {{name}} não encontrado',
				INVALID_LOGIN: 'Os dados de login estão incorretos',
				REQUIRED_FIELD: 'Campo requerido',
				MIN_LENGTH_FIELD: 'Tamanho mínimo do campo:',
				MAX_LENGTH_FIELD: 'Tamanho máximo do campo:',
				INVALID_FIELD: 'Campo inválido',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		}
	}
};
